declare const process: any;

class Configuration {
  DRIVERS_BACK_END: any;
  DRIVERS_BACK_END_WS: string;
  TRANSLATIONS_BACK_END: any;
  INTERCOM_ANDROID_API_KEY: string;
  INTERCOM_IOS_API_KEY: string;
  INTERCOM_APP_ID: string;
  SENTRY_DSN: any;
  SPEECH_TO_TEXT_API_KEY: string;
  ENVIRONMENT: string;
  OTP_VALIDATOR: string;
  POSTHOG_KEY: string;

  constructor() {
    this.DRIVERS_BACK_END = process.env.NX_PUBLIC_DRIVERS_BACK_END;
    this.DRIVERS_BACK_END_WS = process.env.NX_PUBLIC_DRIVERS_BACK_END_WS;
    this.TRANSLATIONS_BACK_END = process.env.NX_PUBLIC_TRANSLATIONS_BACK_END;
    this.INTERCOM_ANDROID_API_KEY = process.env.NX_PUBLIC_INTERCOM_ANDROID_API_KEY;
    this.INTERCOM_IOS_API_KEY = process.env.NX_PUBLIC_INTERCOM_IOS_API_KEY;
    this.INTERCOM_APP_ID = process.env.NX_PUBLIC_INTERCOM_APP_ID;
    this.SENTRY_DSN = process.env.NX_PUBLIC_SENTRY_DSN;
    this.SPEECH_TO_TEXT_API_KEY = process.env.NX_PUBLIC_SPEECH_TO_TEXT_API_KEY;
    this.ENVIRONMENT = process.env.NX_PUBLIC_ENVIRONMENT;
    this.OTP_VALIDATOR = process.env.NX_PUBLIC_OTP_VALIDATOR;
    this.POSTHOG_KEY = process.env.NX_PUBLIC_POSTHOG_KEY;
  }
}
const configuration = new Configuration();
export default configuration;
